import { ServiceModalInnerContainerStyles } from "../ServiceModal.styles";
import { ModalConstructor } from "../../ModalConstructor";
import { SyntheticEvent, useEffect, useRef, useState } from "react";
import { LoadingStack, ReactedTabPanel } from "./ReactionsListModal.styles";
import { MODAL_TITLE_STYLES } from "../../../../../styles";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { ROOT_MARGIN } from "../../../Post/PostsWrapper";
import { useLoadItems } from "./useLoadItems";
import { CommunityCircularProgress } from "../../../../Shared/styles";
import { EntityOptionsModalType } from "./ReactionsListModal.types";
import { ReactionsListTabs } from "./ReactionsListTabs";
import { ReactionsListTabsContent } from "./ReactionsListTabsContent";

export function EntityReactionsListModal(props: EntityOptionsModalType) {
    function handleClosingCurrentModal() {
        props.setOpen(false);
    }

    useEffect(() => {
        return () => {
            handleClosingCurrentModal();
        };
    }, []);

    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const {
        loading,
        items: tabs,
        hasNextPage,
        error,
        loadMore,
        isInitDone,
    } = useLoadItems(
        props.initialfetcher,
        props.mainFetcher,
        props.itemId.toString(),
        tabIndex,
    );

    const [infiniteRef] = useInfiniteScroll({
        loading,
        hasNextPage,
        onLoadMore: loadMore,
        disabled: !!error,
        rootMargin: ROOT_MARGIN.SEMI_LAZY,
    });

    const modalContentRef = useRef<HTMLDivElement>();
    useEffect(() => {
        if (modalContentRef.current) {
            modalContentRef?.current?.scrollTo(0, 0);
        }
    }, [tabIndex]);
    return (
        <ModalConstructor
            scrollableContainerRef={modalContentRef}
            onClose={handleClosingCurrentModal}
            open={props.open}
            modalTitle={
                <ReactionsListTabs
                    tabs={tabs}
                    onChange={handleChange}
                    tabIndex={tabIndex}
                />
            }
            modalContent={
                <>
                    {!isInitDone && (
                        <LoadingStack>
                            <CommunityCircularProgress />
                        </LoadingStack>
                    )}
                    <ReactionsListTabsContent
                        onChange={setTabIndex}
                        tabIndex={tabIndex}
                        tabs={tabs}
                    />
                    <ReactedTabPanel>
                        {!loading && (!isInitDone || hasNextPage) && (
                            <div ref={infiniteRef} />
                        )}
                        {loading && <CommunityCircularProgress />}
                    </ReactedTabPanel>
                </>
            }
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={{
                ...ServiceModalInnerContainerStyles,
                minHeight: "70vh",
                "& .MuiDialogContent-root": {
                    padding: "12px 0",
                },
                "& .MuiDialogTitle-root": {
                    padding: "0",
                    margin: 0,
                    ...MODAL_TITLE_STYLES,
                    borderBottom: "none",
                    "p:first-of-type": { ...MODAL_TITLE_STYLES },
                },
            }}
        />
    );
}
